import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import {
  selectCiudades,
  selectDepartamentos,
  selectTiposDocumento,
} from 'src/app/store/selectors/maestros.select';
import { AppState } from 'src/app/store/state/app.state';
import { Ciudad } from 'src/app/pago/models/Ciudad.model';
import { Departamento } from 'src/app/pago/models/Departamento.model';
import { Maestro } from 'src/app/pago/models/Maestro.model';
import { BaseFacade } from 'src/app/pago/services/base-facade/BaseFacade';

@Injectable({
  providedIn: 'root',
})
export class MaestroFacade extends BaseFacade {
  tiposDeDocumento$: Observable<Maestro[]>;
  ciudades$: Observable<Ciudad[]>;
  departamentos$: Observable<Departamento[]>;

  constructor(protected store: Store<AppState>) {
    super(store);
    this.tiposDeDocumento$ = this.store.select(selectTiposDocumento);
    this.ciudades$ = this.store.select(selectCiudades);
    this.departamentos$ = this.store.select(selectDepartamentos);
  }
}
